export default __webpack_public_path__ + "static/media/affinity_solutions.a7508305.svg";